var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{class:{'length-error': _vm.length},attrs:{"outlined":"","label":"Descrizione","counter":"160"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})}
var staticRenderFns = []

export { render, staticRenderFns }